import React from "react"
import { useDrag } from "react-dnd"
import { Paper, Stack, Avatar, Typography } from "@mui/material"
import SettingsIcon from "@mui/icons-material/Settings"
import { ItemTypes } from "../VisualEditorContext"

const DraggableSection = ({ section }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemTypes.SECTION,
    item: { type: ItemTypes.SECTION, section },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }), [section])

  return (
    <Paper
      ref={drag}
      elevation={0}
      sx={{
        p: 1.5,
        cursor: "grab",
        opacity: isDragging ? 0.5 : 1,
        border: "1px solid #e2e8f0",
        borderRadius: 2,
        transition: "all 0.2s ease",
        "&:hover": {
          borderColor: "#3b82f6",
          bgcolor: "#f8fafc",
          transform: "translateY(-2px)",
          boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
        },
        "&:active": {
          cursor: "grabbing",
        },
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Avatar
          sx={{
            bgcolor: "#dbeafe",
            color: "#3b82f6",
            width: 32,
            height: 32,
          }}
        >
          <SettingsIcon sx={{ fontSize: 16 }} />
        </Avatar>
        <Typography variant="body2" fontWeight={500} color="#1e293b">
          {section.name}
        </Typography>
      </Stack>
    </Paper>
  )
}

export default DraggableSection
